import { Link } from '@elements/link'
import { FacebookLogo } from '@icons/facebook'
import { InstagramLogo } from '@icons/instagram'
import { TikTokLogo } from '@icons/tiktok'
import { TwitterLogo } from '@icons/twitter'
import { Venue } from 'types/model'
import { validateSocialMediaUrl } from '@utils/urls'

export function VenueSocialLinks({ venue }: { venue: Venue }) {
  const { facebook, twitter, instagram, tiktok } = venue.details.social ?? {}

  // Validate URLs
  const validatedFacebook = validateSocialMediaUrl(facebook, 'facebook')
  const validatedTwitter = validateSocialMediaUrl(twitter, 'twitter')
  const validatedInstagram = validateSocialMediaUrl(instagram, 'instagram')
  const validatedTikTok = validateSocialMediaUrl(tiktok, 'tiktok')

  return (
    <nav>
      <ul className='flex items-center space-x-3'>
        {validatedFacebook && (
          <li>
            <Link
              className='!text-inherit !fill-inherit'
              target='_blank'
              rel='noreferrer'
              href={validatedFacebook}
            >
              <FacebookLogo
                className='w-4 h-auto sm:w-5'
                title={`${venue.name} Facebook Profile`}
              />
            </Link>
          </li>
        )}
        {validatedTwitter && (
          <li>
            <Link
              className='!text-inherit !fill-inherit'
              target='_blank'
              rel='noreferrer'
              href={validatedTwitter}
            >
              <TwitterLogo
                className='w-4 h-auto sm:w-5'
                title={`${venue.name} Twitter Profile`}
              />
            </Link>
          </li>
        )}
        {validatedInstagram && (
          <li>
            <Link
              className='!text-inherit !fill-inherit'
              target='_blank'
              rel='noreferrer'
              href={validatedInstagram}
            >
              <InstagramLogo
                className='w-4 h-auto sm:w-5'
                title={`${venue.name} Instagram Profile`}
              />
            </Link>
          </li>
        )}
        {validatedTikTok && (
          <li>
            <Link
              className='!text-inherit !fill-inherit'
              target='_blank'
              rel='noreferrer'
              href={validatedTikTok}
            >
              <TikTokLogo
                className='w-4 h-auto sm:w-5'
                title={`${venue.name} TikTok Profile`}
              />
            </Link>
          </li>
        )}
      </ul>
    </nav>
  )
}
